import { render, staticRenderFns } from "./Remitos-de-venta.vue?vue&type=template&id=6bb6a6dc&scoped=true"
import script from "./Remitos-de-venta.vue?vue&type=script&lang=js"
export * from "./Remitos-de-venta.vue?vue&type=script&lang=js"
import style0 from "./Remitos-de-venta.vue?vue&type=style&index=0&id=6bb6a6dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb6a6dc",
  null
  
)

export default component.exports